import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { ArticleType } from 'src/erp-articles/article-types/article-type.model';
import { ArticleTypeService } from 'src/erp-articles/article-types/article-type.service';
import { Component, OnInit, Input } from '@angular/core';
import { BasicArticle, BasicArticleAttributeValue } from '../basicarticle.model';
import { IdGeneratorService } from 'src/common/services/id-generator.service';

@Component({
  selector: 'app-basicarticle-attributes',
  templateUrl: './basicarticle-attributes.component.html',
  styleUrls: ['./basicarticle-attributes.component.scss']
})
export class BasicarticleAttributesComponent implements OnInit {

  private _basicArticle: BasicArticle;

  articleType: ArticleType;

  attributeFormGroup = new FormGroup({});

  @Input() formGroup: FormGroup;

  @Input('basicArticle') set setBasicArticle(basicArticle: BasicArticle) {
    console.log('basisartikel ist', basicArticle);
    this._basicArticle = basicArticle;
    this.articleType = this.articleTypeService.getById(basicArticle.articleTypeId).completeArticleType;
    this.updateFormFields();
  }

  get basicArticle() {
    return  this._basicArticle;
  }

  constructor(private articleTypeService: ArticleTypeService, private idGenerator: IdGeneratorService) { }

  ngOnInit(): void {

  }

  private updateFormFields() {
    this.attributeFormGroup = new FormGroup({});
    this.formGroup.removeControl('attributes');
    this.formGroup.addControl('attributes', this.attributeFormGroup);

    this.attributeFormGroup.statusChanges.subscribe(status => {
      console.log('attributeForm.statusChanges', status, this.formGroup);
    });

    if (this.articleType != null && this.articleType.basicArticleDefinition != null) {
      const attributesFormValues = {};
      // ensure form fields are always rendered in same ordering
      this.sortAttributes();
      for (const attribute of this.articleType.basicArticleDefinition.attributes) {
        if (attribute.articleTypeAttribute != null) {
          const value = this.basicArticle.getValueByAttributeId(attribute.attributeId);
          attributesFormValues['attr-' + attribute.attributeId] = value != null ? value : null;
          const validators = [];
          if (attribute.articleTypeAttribute.mandatory === true) {
            validators.push(Validators.required);
          }
          this.attributeFormGroup.addControl('attr-' + attribute.attributeId, new FormControl(null, validators));
          console.log('attributes: set formvalue', 'attr-' + attribute.attributeId, value);
          this.attributeFormGroup.controls['attr-' + attribute.attributeId].setValue(value != null ? value.value : '');
        }
      }

      // trigger form validation
      this.attributeFormGroup.markAllAsTouched();

      this.attributeFormGroup.valueChanges.subscribe(values => {
        console.log('attributeForm.valuesChanges', values, this.formGroup);
        for (const attribute of this.articleType.basicArticleDefinition.attributes) {
          let value = this.basicArticle.getValueByAttributeId(attribute.attributeId);
          if (values['attr-' + attribute.attributeId]) {
            if (value == null) {
              value = new BasicArticleAttributeValue({ id: this.idGenerator.getNextId(), attributeId: attribute.attributeId });
              this.basicArticle.addValue(value);
            }
            value.value = values['attr-' + attribute.attributeId];
          }
        }
      });

    }
  }

  private sortAttributes() {
    this.articleType.basicArticleDefinition.attributes.sort( (a, b) => {
      if (a == null || a.articleTypeAttribute == null || a.articleTypeAttribute.sortValue == null) {
        return -1;
      }
      if (b == null || b.articleTypeAttribute == null || b.articleTypeAttribute.sortValue == null) {
        return 1;
      }
      return a.articleTypeAttribute.sortValue.localeCompare(b.articleTypeAttribute.sortValue);
    });
  }
}
